<template>
  <div class="columns login-block">
    <div class="column is-4" />
    <div class="column is-4">
      <h2 class="subtitle is-2 has-text-centered">
        Login
      </h2>
      <div class="box">
        <div class="is-clearfix">
          <router-link to="/">
            <button
              class="delete is-pulled-right mb-2"
              aria-label="close"
            />
          </router-link>
        </div>
        <form>
          <div class="field">
            <label class="label">Email</label>
            <p class="control has-icon has-icon-right">
              <input
                v-model="email"
                class="input"
                type="email"
                placeholder="jsmith@example.com"
              >
              <span class="icon">
                <i class="far fa-user" />
              </span>
            </p>
          </div>
          <div class="field">
            <label class="label">Password</label>
            <p class="control has-icon has-icon-right">
              <input v-if="showPassword" v-model="password" class="input" type="text" @keydown.enter="login()">
              <input v-if="!showPassword"
                v-model="password"
                class="input"
                type="password"
                placeholder="******"
                @keydown.enter="login()"
              >
              <span class="icon">
                <i class="far fa-lock" />
              </span>
              <div @click="showPassword = !showPassword" style="cursor:pointer;margin-top:10px;margin-bottom:15px;">
                <i :class="{'far': true, 'fa-eye': !showPassword, 'fa-eye-slash': showPassword}"></i>
                {{!showPassword ? 'Show' : 'Hide'}} Password
              </div>
            </p>
          </div>
          <div class="field has-text-info has-text-centered">
            <router-link to="/restore-password">
              Forgot password?
            </router-link>
          </div>
          <div class="field">
            <label class="checkbox">
              <input
                v-model="rememberMe"
                type="checkbox"
                :checked="rememberMe"
              >
              Remember me
            </label>
          </div>
          <div class="field">
            <div class="control">
              <button
                class="button is-info is-fullwidth"
                type="button"
                @click="login()"
              >
                Login
              </button>
            </div>
          </div>
          <!--
                        <div class="label is-size-7 label-or has-text-centered">OR</div>
                        <div class="field">
                            <div class="control" @click="loginViaFacebook()">
                                <button class="button is-info is-fullwidth" type="button"><i class="fab fa-facebook-square pr-2"></i> Sign in with Facebook</button>
                            </div>
                        </div>
                        -->
        </form>
        <div
          v-if="errorMessage"
          class="error"
        >
          <br>
          {{ errorMessage }}
        </div>
      </div>
    </div>
    <div class="column is-4" />
  </div>
</template>
<style scoped lang="less">
  .error {
    color: red;
  }
</style>

<script>
  import axios from 'axios'
  export default {
    name: 'LoginUser',
    data () {
      return {
        showPassword: false,
        errorMessage: null,
        loginWindow: false,
        email: '',
        password: '',
        fbid: '',
        rememberMe: true
      }
    },
    mounted () {
      if (localStorage.getItem('email')) {
        this.email = localStorage.getItem('email')
      }
      if (localStorage.getItem('password')) {
        this.password = localStorage.getItem('password')
      }
    },
    methods: {
      emailValidation () {
        let regex = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (regex.test(this.email)) {
          return true
        } else return false
      },
      login () {
        if (this.emailValidation() || this.fbid) {
          this.errorMessage = ''
          let data
          if (this.fbid) {
            data = {
              userid: this.fbid
            }
          } else {
            data = {
              username: this.email,
              password: this.password,
              rememberme: this.rememberMe
            }
          }
          this.$axios({
            method: 'POST',
            url: 'authenticate/login',
            headers: {
              Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            data
          })
            .then((res) => {
              if (this.rememberMe) {
                window.localStorage.setItem('isLoggedIn', JSON.stringify(res.data))
                localStorage.setItem('email', this.email)
                localStorage.setItem('password', res.data.user.encToken)
              }
              this.$emit('loginUser', res.data)
              this.$emit('message',
                {
                  error: false,
                  showNotification: true,
                  showDialog: false,
                  message: `Welcome to AHL Poker, ${res.data.user.first}!`
                })
              this.$router.push({path: '/'})
            })
            .catch((error) => {
              this.$emit('message',
                {
                  error: true,
                  showNotification: true,
                  showDialog: false,
                  message: error.response.data.message
                })
              this.errorMessage = error.response.data.message
              this.$router.push('/')
            })
        } else {
          this.errorMessage = 'Invalid email format'
        }
      },
      loginViaFacebook () {
        window.FB.getLoginStatus((response) => {
          if (response.status === 'connected') {
            this.fbid = response.authResponse.userID
            this.login()
            console.log(response, 'logged in')
          } else {
            window.FB.login((res) => {
              this.fbid = response.authResponse.userID
              this.login()
              console.log(res)
            })
          }
        })
      }
    }
  }
</script>
